import logo from "../assets/images/logo-winston-kampaay.png"
import * as React from "react";

const CustomLogo = ({width, height, bw = true}) => {
    return (
        <img src={logo} width={width} height={height}
             style={{
                 display: { xs: 'none', md: 'flex' },
                 objectFit: 'contain',
                 //margin: '1rem 1rem',
                 filter: bw ? 'brightness(0) invert(1)' : ''
        }}/>
    )
}

export default CustomLogo